import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Fireball = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Fireball' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,13 L10.25,14 L11,12 L9.75,11 L11.25,11 L12,9.25 L12.75,11 L14.25,11 L13,12 L13.75,14 L12,13 Z' />
  </StyledIcon>
);
